import { PlaybookStatus } from '@driftt/api-types'
import {
  GlobalStore,
  tracking,
  TrackingProperties,
} from '@driftt/traffic-control'
import { pathOr } from 'ramda'

import { NovelExample } from 'api/topicTraining'
import { BotType } from 'components/EditorNavigation/BuildABotModal'

export const { trackEvent } = tracking
const playbook = () => GlobalStore.getState().__PLAYBOOK_EDITOR.playbook
const user = () => GlobalStore.getState().user

const trackBotEvent = (eventName: string, properties?: TrackingProperties) => {
  trackEvent(eventName, {
    playbookId: playbook().id,
    playbookType: 'BOT',
    ...properties,
  })
}

export const trackDefaultPlaybookStatusToggled = (
  defaultPlaybookName: string,
  status: PlaybookStatus
) => {
  trackEvent('Default Playbooks - Status Toggled', {
    status: status,
    playbookName: defaultPlaybookName,
  })
}

export const trackClpPdfContent = (properties: TrackingProperties) => {
  trackEvent('Clp Content Uploaded', { ...properties })
}

export const trackClpNoContent = (properties: TrackingProperties) => {
  trackEvent('Clp with no content selected', { ...properties })
}

export const trackClpContentUsage = (
  data: { hasContent?: boolean },
  properties: TrackingProperties
) => {
  const contentUrl = pathOr('', ['contentSettings', 'contentUrl'], data)

  if (!!contentUrl && data.hasContent) {
    trackClpPdfContent(properties)
  } else {
    trackClpNoContent(properties)
  }
}

export const trackEmbeddedClpCodeModal = (
  isOpen: boolean,
  properties: TrackingProperties
) => {
  trackEvent(`Embedded CLP - Code Modal ${isOpen ? `Opened` : `Closed`}`, {
    ...properties,
  })
}

export const trackEmbeddedClpEmailModal = (
  isOpen: boolean,
  properties: TrackingProperties
) => {
  trackEvent(`Embedded CLP - Email Modal ${isOpen ? `Opened` : `Closed`}`, {
    ...properties,
  })
}

export const trackEmbeddedClpCodeCopy = (properties: TrackingProperties) => {
  trackEvent('Embedded CLP - Code Copied', { ...properties })
}

export const trackEmbeddedClpEmailSent = (properties: TrackingProperties) => {
  trackEvent('Embedded CLP - Email Sent', { ...properties })
}

export const trackPlaybookPublish = (publishTime: number) => {
  trackBotEvent('Bot Flow Published', { timeAsSeconds: publishTime })
}

export const trackTimeToPublish = (properties: TrackingProperties) => {
  trackBotEvent('Time To Bot Flow Publish', { ...properties })
}

export const trackBranchingOptIn = () => {
  trackBotEvent('Bot Builder Branching - OPT IN')
}

export const trackBranchingOptOut = () => {
  trackBotEvent('Bot Builder Branching - OPT OUT')
}

export const trackPlaybookUpdate = () => {
  trackBotEvent('Bot Flow Auto Save Success')
}

export const trackClickedOnAnalytics = () => {
  trackBotEvent('Bot Flow Analytics Link Clicked')
}

export const trackClickedOnSettings = () => {
  trackBotEvent('Playbook Settings Link Clicked')
}

export const trackPlaybookReverted = () => {
  trackBotEvent('Playbook Reverted')
}

export const trackPlaybookValidationFailure = () => {
  trackBotEvent('Playbook Validation Failed')
}

export const trackBotFlowShareClick = () => {
  trackBotEvent('Bot flow share modal opened')
}

export const trackBotFlowShareLinkCopyClick = () => {
  trackBotEvent('Bot flow share link copied')
}

export const trackBotFlowPreviewFL = () => {
  trackBotEvent('Bot flow test button clicked - FL', { user: user() })
}

export const trackBotFlowPreview = () => {
  trackBotEvent('Bot flow test button clicked', { user: user() })
}

export const trackBotFlowPreviewExperiment = (flow: string) => {
  trackBotEvent(`Bot flow test button clicked - Flow: ${flow}`, {
    user: user(),
  })
}

export const trackBotFlowPreviewCLP = () => {
  trackBotEvent('Bot flow test button clicked - CLP', { user: user() })
}

export const trackPlaybookStatusToggled = (
  status: PlaybookStatus,
  location: string
) => {
  trackBotEvent('Playbook Status Toggled', {
    status,
    location,
  })
}

export const trackClickedOnVersionHistoryDropdown = () => {
  trackBotEvent('Playbook Version History Dropdown Clicked')
}

export const trackClickedOnPreviewPlaybook = () => {
  trackBotEvent('Playbook Previewed')
}

export const trackClickedOnCurrentPlaybookVersion = () => {
  trackBotEvent('Current Playbook Version Clicked')
}

export const trackClickedOnRestorePlaybook = () => {
  trackBotEvent('Restore Playbook Button Clicked')
}

export const trackAttemptsToEditPlaybookInPreviewState = () => {
  trackBotEvent('Playbook Edit Prevented')
}

export const trackAudienceEducationViewed = (hasSeenEduNudge: boolean) => {
  trackEvent('In App Education - Viewed', {
    page: 'audience',
    nudge: !hasSeenEduNudge,
  })
}

export const trackAudienceEducationOpened = (hasSeenEduNudge: boolean) => {
  trackEvent('In App Education - Opened', {
    page: 'audience',
    nudge: !hasSeenEduNudge,
  })
}

export const trackAudienceEducationWatched = (
  hasSeenEduNudge: boolean,
  link: string
) => {
  trackEvent('In App Education - Watched', {
    page: 'audience',
    nudge: !hasSeenEduNudge,
    link: link,
  })
}

export const trackAudienceEducationClosed = (hasSeenEduNudge: boolean) => {
  trackEvent('In App Education - Closed', {
    page: 'audience',
    nudge: !hasSeenEduNudge,
  })
}

/////////// IN-APP EDU \\\\\\\\\\
export const trackMagnusEducationViewed = (hasSeenEduNudge: boolean) => {
  trackEvent('In App Education - Viewed', {
    page: 'visual-builder',
    nudge: !hasSeenEduNudge,
  })
}

export const trackMagnusEducationOpened = (hasSeenEduNudge: boolean) => {
  trackEvent('In App Education - Opened', {
    page: 'visual-builder',
    nudge: !hasSeenEduNudge,
  })
}

export const trackMagnusEducationWatched = (
  hasSeenEduNudge: boolean,
  link: string
) => {
  trackEvent('In App Education - Watched', {
    page: 'visual-builder',
    nudge: !hasSeenEduNudge,
    link: link,
  })
}

export const trackMagnusEducationClosed = (hasSeenEduNudge: boolean) => {
  trackEvent('In App Education - Closed', {
    page: 'visual-builder',
    nudge: !hasSeenEduNudge,
  })
}

/* AUDIENCE ESTIMATOR TRACKING */
export function trackHelpContentDrawerOpened() {
  trackEvent('Audience Estimator Help Content Drawer Opened')
}

export function trackReachAPICallFailures(error: string) {
  trackEvent('Reach API Failed', { error })
}

export const trackSiteCoverageEmptyFilterUrlResults = (filterUrl: string) =>
  trackEvent('No pages match search', {
    filterUrl,
    page: 'targeting/builder',
  })

export const trackSwitchTargetingBuilderType = ({
  hasConditions,
  switchTo,
}: {
  hasConditions: boolean
  switchTo: string
}) =>
  trackEvent('Switch Targeting Builder Type', {
    hasConditions,
    page: 'targeting/builder',
    switchTo,
  })

export const trackExperimentCreated = () =>
  trackEvent('Playbook Experiment Created')

export const trackExperimentStarted = () =>
  trackEvent('Playbook Experiment Started')

export const trackExperimentBotFlowDeleted = ({ flow }: { flow: 'A' | 'B' }) =>
  trackEvent('Playbook Experiment Bot Flow Deleted', { flow })

export const trackExperimentEnded = ({
  duration,
  winner,
}: {
  duration: number
  winner?: 'A' | 'B'
}) => trackEvent('Playbook Experiment Ended', { duration, winner })

export const trackFormMappingHelpContentClick = () => {
  trackEvent('Form Mapping Help Content Clicked')
}

/** @deprecated */
export const trackAIBotResponsesPageVisted = () => {
  trackEvent('AI Bot Responses - Page visited')
}

/** @deprecated */
export const trackAIBotResponseEdit = (properties: TrackingProperties) => {
  trackEvent('AI Bot Responses - Response edited', { ...properties })
}

export const trackAITopicsPageVisted = () =>
  trackEvent('AI Topics - Page visited')

export const trackAITopicsAction = (
  action: string,
  properties?: TrackingProperties
) => trackEvent('AI Topics - Action', { action, ...properties })

export const trackAITopicCreateButtonClicked = () =>
  trackAITopicsAction('create button clicked')

export const trackAITopicCreated = () => trackAITopicsAction('created')

export const trackAITopicUpdated = (
  topicId: string,
  properties: {
    nameUpdated: boolean
    replyUpdated: boolean
    examplesUpdated: boolean
  }
) => trackAITopicsAction('updated', { topicId, ...properties })

export const trackAITopicArchived = (topicId: string) => {
  trackAITopicsAction('archived', { topicId })
}

export const trackAITopicRestored = (topicId: string) => {
  trackAITopicsAction('restored', { topicId })
}

export const trackAITopicViewed = (topicId: string) => {
  trackAITopicsAction('viewed', { topicId })
}

export const trackAIDiscoveryPageVisited = () =>
  trackEvent('AI Discovery - Page visited')

export const trackAIDiscoveryAction = (
  action: string,
  example: NovelExample,
  properties?: TrackingProperties
) =>
  trackEvent('AI Discovery - Action', {
    action,
    exampleId: example.id,
    suggestedTopicId: example.suggestedTopicId,
    ...properties,
  })

export const trackAITopicsPublishRequested = () =>
  trackEvent('AI Topics - Publish requested')

export const trackHowToBuildABotEduClicked = () =>
  trackEvent('How to build a bot - clicked')

export const trackHowToBuildABotTypeToggled = (botType: BotType) =>
  trackEvent('How to build a bot - type toggled', { botType })

export const trackHowToBuildABotInsiderLinkClicked = (botType: BotType) =>
  trackEvent('How to build a bot - Drift Insider link clicked', { botType })
